import {UserWithdrawalDomain} from "../../domain/user/UserWithdrawalDomain"
import {UserId} from "../../id/user/UserId"
import {UserWithdrawalId} from "../../id/user/UserWithdrawalId"
import {UserWithdrawalReasonId} from "../../id/user/UserWithdrawalReasonId"
import {ValueObject} from "ts-protocol-extension"

/**
 * 사용자 탈퇴
 */
export class UserWithdrawalValueObject implements ValueObject, UserWithdrawalDomain {
    /**
     * 기본키
     */
    id: UserWithdrawalId
    /**
     * 사용자 ID
     */
    userId: UserId
    /**
     * 사용자 탈퇴 사유 ID
     */
    userWithdrawalReasonId: UserWithdrawalReasonId
    /**
     * 생성일
     */
    createdAt: Date

    constructor(o: Record<keyof UserWithdrawalDomain, any>) {
        this.id = BigInt(o.id)
        this.userId = BigInt(o.userId)
        this.userWithdrawalReasonId = BigInt(o.userWithdrawalReasonId)
        this.createdAt = new Date(o.createdAt)
    }
}
